import { ColDef } from "ag-grid-community";

export const serialNumberColumn: ColDef = {
    headerName: 'S.No.',
    valueGetter: (params) =>
      params.node?.id != null ? parseInt(params.node.id, 10) + 1 : '',
    width: 90,
    pinned: 'left',
    filter: 'agNumberColumnFilter',
    sortable: false,
    cellStyle: { textAlign: 'center' },
  };
  